import React from 'react';
// import { connect } from 'react-redux';
import styles from './index.module.scss';

export interface IFilterControl {
  label?: string;
  labelColLen?: number;
  ctrl?: JSX.Element;
}

interface IProps {
  // storage?: IDataStorage;

  controls?: IFilterControl[][];
  className?: string;
}

interface IState {
  // storage?: IDataStorage;

  controls?: IFilterControl[][];
  className?: string;
}

class FilterPanel extends React.Component<IProps, IState> {
  componentDidMount = () => FilterPanel.getDerivedStateFromProps(this.props, this.state);
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.controls !== s?.controls) res.controls = p.controls;
    if (p?.className !== s?.className) res.className = p.className;
    return res;
  }

  render() {
    const { controls } = this.state;
    
    return <>
      <div className={`p-fluid p-shadow-2 ${styles["filter-panel"]} ${this.state.className ?? ''}`}>
        {controls?.map(row => {
          const col = Math.max(Math.round(12 / row.length), 1);

          return <div className="p-grid">
            {row.map(ctrl => 
              <>
                {!!ctrl.label && <label className={`p-col-${ctrl.labelColLen ?? 1}`}>{ctrl.label}</label>}
                <div className={`p-col-${col - (!!ctrl.label ? (ctrl.labelColLen ?? 1) : 0)}`}>{ctrl.ctrl}</div>
              </>
            )}
          </div>
        })}
      </div>
    </>;
  }
}

//export default connect((s:any) => ({ storage:s.main }))(FilterPanel);
export default FilterPanel;
